import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../components/Reporting';
import { useEffect } from 'react';
import LumenLoader from '../../../Loader';

interface LocationsChartProps {
    productLineCode?: string;
}

const LocationsChart: React.FunctionComponent<LocationsChartProps> = (props) => {
    const { productLineCode } = props;
    const PRODUCTION_BOUND_POLICIES_ID = '4811c819-b3e5-4f9f-aa91-0bea9fdb9cc4';
    const PRODUCTION_BOUND_POLICIES_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';
    const PRODUCTION_BOUND_POLICIES_PAGENAME = '007996ada2c47a3bb063';

    const [delaying, setDelaying] = React.useState(false);

    useEffect(() => {
        if (delaying) {
            setTimeout(() => {
                setDelaying(false);
            }, 8500);
        }
    }, []);

    if (delaying) {
        return <LumenLoader fillHeight={'100%'} />;
    }

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={PRODUCTION_BOUND_POLICIES_ID}
                workspaceId={PRODUCTION_BOUND_POLICIES_WORKSPACE_ID}
                height={'100%'}
                hidePageNav
                hideFilters
                pageName={PRODUCTION_BOUND_POLICIES_PAGENAME}
                hideReportBorder
                filter={{
                    table: 'POLICY_DIM',
                    column: 'PRODUCT_LINE_TYPE_CODE',
                    filter: [productLineCode || 'COMMERCIAL_PROPERTY'],
                }}
            />
        </>
    );
};

export default LocationsChart;
